import { PushDeviceHttpGateway } from 'src/adapters/http/PushDeviceHttpGateway'
import { NativePushBridge } from 'src/adapters/native/NativePushBridge'
import { PushTopicStore } from 'src/adapters/native/PushTopicStore'
import { DisablePushDevice } from './DisablePushDevice'
import { ForgetPushDevice } from './ForgetPushDevice'
import { LogoutPushDevice } from './LogoutPushDevice'
import { PreparePush } from './PreparePush'
import { RegisterPushDevice } from './RegisterPushDevice'
import { SyncNewsTopics } from './SyncNewsTopics'

// Сборка зависимостей вручную: мост обёртки и реестр устройств notifire.
export const pushBridge = new NativePushBridge()
export const syncNewsTopics = new SyncNewsTopics(pushBridge, new PushTopicStore())
const deviceGateway = new PushDeviceHttpGateway()

export const preparePush = new PreparePush(pushBridge)
export const registerPushDevice = new RegisterPushDevice(pushBridge, deviceGateway)
export const forgetPushDevice = new ForgetPushDevice(pushBridge)
export const logoutPushDevice = new LogoutPushDevice(pushBridge, deviceGateway)
export const disablePushDevice = new DisablePushDevice(pushBridge, deviceGateway)
